module.exports = __webpack_public_path__ + "img/V-63-ST-1000-N.f0faef9a.png";